import React from "react";
import { PlusSVG } from "./icons";
import { useTranslation } from "react-i18next";

export default function NewChatButton({ onNewChat }) {
  const { t } = useTranslation();

  return (
    <div
      className="new-chat-button h-[64px] m-[8px] rounded-md bg-[white] cursor-pointer
                 rounded-md 
                 transition-all duration-200 ease-in-out 
                 hover:scale-[1.01] hover:shadow-xl 
                 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      style={{ border: "1px dashed #00000069" }}
      onClick={onNewChat}
    >
      <div className="new-chat-wrapper h-full w-full flex flex-col items-center justify-center">
        <div className="text">
          <span className="inline-flex items-center text-[var(--black-text)] text-[15px]">
            <PlusSVG fill="#000" size="20" />
            {t("work.new_chat")}
          </span>
        </div>
        <div className="desc text-[#515154] text-[14px]">
          Start a new chat
        </div>
      </div>
    </div>
  );
}
